import * as updateActions from '../../actions/application-update-permissions.actions';
import { ApplicationUpdatePermissions } from '../../model/application/application-update-permissions.model';
import { AuthorizationModal } from '../../../../core/model/authorization/authorization-modal.model';

/**
 * Reducer handles authorization object returned from API when updating application permission.
 *
 * - authorization - returned by API when updating permissions
 * - authorizationResponse - message posted by MEP IFrame authorization
 */
export function updatePermissions(
    state: AuthorizationModal<ApplicationUpdatePermissions> = null, action: updateActions.Actions): AuthorizationModal<ApplicationUpdatePermissions> {
    switch (action.type) {
        case updateActions.UPDATE_PERMISSIONS_SUCCESS:
            return {...state, shown: true, authorization: {...state.authorization, ...action.payload}};
        case updateActions.UPDATE_PERMISSIONS_CANCEL:
        case updateActions.UPDATE_PERMISSIONS_CLEAN:
        case updateActions.UPDATE_PERMISSIONS_AUTH_ERROR:
            return {...state, shown: false, authorization: null, authorizationResponse: null};
        case updateActions.UPDATE_PERMISSIONS_AUTH_FINISHED:
            return {...state, shown: false, authorizationResponse: action.payload};
        case updateActions.UPDATE_PERMISSIONS_REQUEST:
            return {...state, authorization: {...(state ? state.authorization : <ApplicationUpdatePermissions>{}), appId: action.payload.appId}};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/reducers/enabled-applicaton/application-update-permissions.reducer.ts